export default {
    get_research: state => { return state.launch_research},
    get_reset_submission_list: state => { return state.reset_submission_list},
    get_fnsoum: state => { return state.fnsoum},
    get_frefc: state => { return state.frefc},
    get_fcol: state => { return state.fcol},
    get_fstatus: state => { return state.fstatus},
    get_fdate_soum: state => { return state.fdate_soum},
    get_fcetat: state => { return state.fcetat},
    get_fcetatd: state => { return state.fcetatd},
    get_fcetate: state => { return state.fcetate},
    get_fcetata: state => { return state.fcetata},
    get_fcetatr: state => { return state.fcetatr},
    get_fcetatt: state => { return state.fcetatt},
    get_fcetat_sup: state => { return state.fcetat_sup},
};